// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","root":"root-2A0B-","header":"header-SRNYg","body":"body-1iUCX","footer":"footer--MPGS","promo_message":"promo_message-123Fg"};